import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.name == 'NotFound') {
		document.title = '(XoX)~迷路了'
	}
	else {
		document.title = '主页'
	}
	next();
})

new Vue({
	router,
	data() {
		return {
			width: window.innerWidth - 1,
			height: window.innerHeight - 1
		}
	},
	mounted() {
		window.onresize = () => {
			this.width = window.innerWidth - 1;
			this.height = window.innerHeight - 1;
		}
	},
	render: h => h(App)
}).$mount('#app')
